<button class="btn p-0 mr-4   hamburger-menu" (click)="toggleField()"><img src="../../assets/images/hamburger-menu.svg"
        alt="hamburger-icon" /></button>
<div class="overlay" [class.toggled]="classToggled" (click)="toggleField()"></div>
<div class="category-wrapper new-dropdown-wrapper" [class.toggled]="classToggled">
    <div class="close-btn-wrapper close-button-mobile">
        <button class="btn p-o  close-btn" (click)="toggleField()">
            <img src="../../assets/images/close-menu.svg" alt="close-icon">
        </button>
    </div>
    <div class="link-wrapper">
        <div class="links" (click)="listClick($event, 'All', '/product/listing/All', '')">
            <a (click)="toggleField()" title="all">All</a>
        </div>


        <div class="links">

            <!-- new mobile -design -->
            <div class="btn-group custom-btn-group d-none-block-responsive" dropdown>
                <button id="button-basic" type="button" class="btn" aria-controls="dropdown-basic"
                    (click)="toggleOpen()">
                    Categories <img src="../../assets/images/select-arrow-white.svg" alt="profile" />
                </button>
                <div class="mobile-accordian-main" *ngIf="mobileMain">
                    <accordion [closeOthers]="oneAtATime">
                        <accordion-group *ngFor="let cat of topCategories; let i=index">
                            <button class="btn btn-link btn-block justify-content-between d-flex w-100  shadow-none"
                                accordion-heading type="button">
                                <div *ngIf="cat.sub_cat.length == 0" (click)="listClick($event, cat.id, '/product/listing/' + cat.id + '-' + cat.url_key, cat)" class="pull-left float-left">{{cat.name}}</div>
                                <div *ngIf="cat.sub_cat.length > 0" class="pull-left float-left">{{cat.name}}</div>

                            </button>
                            <ul class="mobile-ul">
                                <li (click)="listClick($event, subcat.id, '/product/listing/' + subcat.id + '-' + subcat.url_key, subcat)"
                                    *ngFor="let subcat of cat.sub_cat">{{subcat.name}}</li>
                            </ul>
                        </accordion-group>
                    </accordion>
                </div>

            </div>
            <!-- Mobile new design end -->

            <div class="btn-group custom-btn-group d-none-responsive">
                <div class="custom-dropdown-desktop">
                    <button>
                        Categories <img src="../../assets/images/select-arrow-white.svg" alt="profile" />
                    </button>
                    <ul id="dropdown-basic" class="dropdown-menu category-list-dropdown" role="menu">

                        <div class="mega-menu-main">
                            <li class="mega-menu-li-main">
                                <ul class="mega-menu-li-inner-main" *ngFor="let cat of topCategories; let i=index">
                                    <li>
                                        <div class="categories-button-main" (mouseenter)="mouseEnter(cat)"
                                            (mouseleave)="mouseLeave('mouse_leave')">
                                            <div class="icon-category">
                                                <img class="" src="../../../../assets/images/category-icon.svg" alt="">
                                            </div>
                                            <span
                                                (click)="listClick($event, cat.id, '/product/listing/' + cat.id + '-' + cat.url_key, cat)"
                                                class="category-text"
                                                *ngIf="cat.sub_cat.length == 0">{{cat.name}}</span>
                                            <span class="category-text"
                                                *ngIf="cat.sub_cat.length > 0">{{cat.name}}</span>
                                            <img class="arrow-categories" src="../../../../assets/images/menu-arrow.svg"
                                                alt="">
                                        </div>
                                        <div class="mega-menu-inner" (mouseenter)="mouseEnter(cat)"
                                            (mouseleave)="mouseLeave('mouse_leave')">
                                            <ul>
                                                <li class="inner-sub-flx"
                                                    (click)="listClick($event, subcat.id, '/product/listing/' + subcat.id + '-' + subcat.url_key, subcat)"
                                                    *ngFor="let subcat of cat.sub_cat">
                                                    <img width="40" *ngIf="subcat.menu_title_image != ''" class="mr-2"
                                                        [src]="statePersist.getSafeUrl(subcat.menu_title_image)" alt="">

                                                    <img width="40" *ngIf="subcat.menu_title_image == ''" class="mr-2"
                                                        src="../../../../assets/images/categary-default-image.svg"
                                                        alt=""> {{subcat.name}}

                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>



                            </li>

                            <li class="empty-li"></li>
                            <li class="images-li">
                                <div class="images-mega-menu">
                                    <img [src]="statePersist.getSafeUrl(topCategoriesDefaultImage)" alt="">

                                </div>
                            </li>
                        </div>
                    </ul>
                </div>

            </div>

        </div>

        <button [ngClass]="{'btn links mx-0 px-0 my-0': true, 'disabled': isNewButtonDisable ? true: false}"
            (click)="scrollToNew()" id="new_btn_of_scroll" [disabled]="isNewButtonDisable">
            <a (click)="toggleField()" title="New">New</a>
        </button>

        <div class="links" (click)="allPromotions()" *ngIf="selectedStore?.selectedStorePromotionApply =='1'">
            <a (click)="toggleField()" title="Promotions">Promotions</a>
        </div>

        <div class="links">

            <div class="btn-group custom-btn-group d-none-block-responsive" dropdown>
                <button id="button-basic" dropdownToggle type="button" class="btn" aria-controls="dropdown-basic">
                    Brands <img src="../../assets/images/select-arrow-white.svg" alt="profile" />
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu category-list-dropdown" role="menu"
                    aria-labelledby="button-basic">


                    <div class="images-brands">
                        <div class="image-tile" *ngFor="let banner of bannerBrands | slice:0:5"
                            (click)="onBrandSelect(banner?.id)">
                            <img [src]="statePersist.getSafeUrl(banner?.image_url)" alt="banner.label"
                                class="brand-images-top ">
                        </div>
                    </div>


                    <div class="mega-menu-main">
                        <li class="mega-menu-li-main">
                            <div class="show-all-brands mobile" [routerLink]="['/product','listing','All']">Show All
                                Brands</div>
                            <ul class="mega-menu-li-inner-main" *ngFor="let brandCat of brandsListByCategory">
                                <li class="w-100">
                                    <div class="categories-button-main" (click)="onBrandCatSelect(brandCat?.brands)">
                                        <div class="icon-category">
                                            <img class="" src="../../../../assets/images/category-icon.svg" alt="">
                                        </div>
                                        <span class="category-text">{{brandCat?.from}}</span>
                                        <img class="arrow-categories" src="../../../../assets/images/menu-arrow.svg"
                                            alt="">
                                    </div>
                                    <ul>
                                        <li class="brands-text-div">

                                            <div class="brand-grid">

                                                <ng-container *ngIf="selectedBrand.length">
                                                    <div class="group" *ngFor="let brandsItem of brandCat.brands">
                                                        <h4 *ngIf="brandsItem.id == ''">{{brandsItem?.label}}</h4>
                                                        <div class="item" *ngIf="brandsItem.id 
                                            != ''" (click)="onBrandSelect(brandsItem.id)">{{brandsItem?.label}}
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <div class="no-listing-brands" *ngIf="!selectedBrand.length">
                                                    <img src="../../../../assets/images/no-listing-mega-meniu.svg"
                                                        alt="">
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </div>


                </ul>
            </div>

            <div class="btn-group custom-btn-group d-none-responsive">
                <div class="custom-dropdown-desktop" (mouseenter)="onDropdownHover(true)">
                    <button>
                        Brands <img src="../../assets/images/select-arrow-white.svg" alt="profile" />
                    </button>
                    <ul id="dropdown-basic" class="dropdown-menu category-list-dropdown brands" role="menu">
                        <div class="images-brands">
                            <div class="image-tile" *ngFor="let banner of bannerBrands | slice:0:5"
                                (click)="onBrandSelect(banner?.id)">
                                <img [src]="statePersist.getSafeUrl(banner?.image_url)" alt="banner.label"
                                    class="brand-images-top ">
                            </div>
                        </div>
                        <div class="mega-menu-main">
                            <li class="mega-menu-li-main">
                                <ul class="mega-menu-li-inner-main" *ngFor="let brandCat of brandsListByCategory">
                                    <li>
                                        <div class="categories-button-main"
                                            (click)="onBrandCatSelect(brandCat?.brands)">
                                            <div class="icon-category">
                                                <img class="" src="../../../../assets/images/category-icon.svg" alt="">
                                            </div>
                                            <span class="category-text">{{brandCat?.from}}</span>
                                            <img class="arrow-categories" src="../../../../assets/images/menu-arrow.svg"
                                                alt="">
                                        </div>
                                    </li>
                                </ul>
                            </li>

                            <li class="brands-text-div">
                                <span class="show-all-brands" [routerLink]="['/product','listing','All']">Show All
                                    Brands</span>
                                <div class="brand-grid">

                                    <ng-container *ngIf="selectedBrand.length">
                                        <div class="group" *ngFor="let brandsItem of selectedBrand">
                                            <h4 *ngIf="brandsItem.id == ''">{{brandsItem?.label}}</h4>
                                            <div class="item" *ngIf="brandsItem.id 
                                            != ''" (click)="onBrandSelect(brandsItem.id)">{{brandsItem?.label}}
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div class="no-listing-brands" *ngIf="!selectedBrand.length">
                                        <img src="../../../../assets/images/no-listing-mega-meniu.svg" alt="">
                                    </div>
                                </div>
                            </li>

                        </div>
                    </ul>
                </div>

            </div>

        </div>


        <div class="links" (click)="listClick($event, 'My Orders', '/order', '')">
            <a (click)="toggleField()" title="My Orders">My Orders</a>
        </div>

    </div>
    <div class="social-icon">
        <a href="{{data?.url}}" title="{{data?.name}}" *ngFor="let data of socialMediaDetail?.socialMediasWOS"
            [ngClass]="{'ml-2': data.name != 'Facebook' ? true: false}" target=”_blank”>
            <img [src]="statePersist.getSafeUrl(data?.image1.url)" alt="{{data?.name}}">
        </a>

    </div>
</div>